import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import CSSTransition from 'react-transition-group/CSSTransition';

// Utils
import {
  calcColumns,
  stepHasRequiredData,
  getStepWaitText,
  isLoadingOnField,
  stepShowHide,
  stepToggleType,
} from '../../../utilities/form/formUtils';

// Constants
import { stepComponents } from '../../../constants/Steps';

// Components
import FormActions from '../../Form/FormActions';
import StepHeader from '../General/StepHeader';
import Text from '../../Global/Text';
import { getStepTitle, triggerView } from '../../../utilities/adobeTarget';

class Basic extends Component {
  componentDidMount() {
    const viewName = getStepTitle();
    if (viewName) {
      triggerView(viewName);
    }
  }

  componentDidUpdate() {
    const viewName = getStepTitle();
    if (viewName) {
      triggerView(viewName);
    }
  }

  render() {
    const {
      componentProps,
      title,
      desc,
      submitText,
      submitButton,
      dispatch,
      errors,
      handleSubmit,
      onBlur,
      onChange,
      setValues,
      touched,
      values,
      tracking,
      setFormValues,
      formActions,
      requiredData,
      userData,
      actionProps,
      actionVariant,
      initialValues,
      setFieldValue,
      className,
      submitIcon,
      applyFormSubmitClass,
      afterButtonTextBody,
      currentSectionId,
    } = this.props;

    const formParams = {
      handleSubmit,
      onChange,
      onBlur,
      errors,
      touched,
      setValues,
      values,
      setFormValues,
      dispatch,
      userData,
      setFieldValue,
      initialValues,
    };

    return (
      <article className={`step step--basic ${className}`}>

        {(title || desc) && (
          <StepHeader title={title} desc={desc}/>
          )}

        {/* If there's any props */}
        {componentProps.length > 0 && (
          <div className="step__content">
            {componentProps.map(componentProp => {
                  const { loadingOnField } = componentProp;
                  const hidden = componentProp.hidden ? componentProp.hidden : false;
                  const showHide = componentProp.showHide ? componentProp.showHide : null;
                  const toggleType = componentProp.toggleType ? componentProp.toggleType : null;
                  const inputParams = {
                    ...componentProp,
                    ...formParams,
                    isLoading: loadingOnField ? isLoadingOnField(loadingOnField, userData) : null,
                    'columns': calcColumns(componentProp),
                    'children': componentProps,
                    hidden: (stepShowHide(hidden, showHide, userData, values)),
                    toggleType: (stepToggleType(toggleType, userData, values)),
                  };

                  const InputComponent = stepComponents[componentProp.type];
                  return (
                    <CSSTransition
                      in={inputParams.hidden !== true}
                      timeout={300}
                      classNames="slideInTop"
                      unmountOnExit
                    >
                      <InputComponent {...inputParams}/>
                    </CSSTransition>
                  );
                })}

            {/* Actions Button */}
            {submitButton &&
            <FormActions
              formActions={formActions}
              submitText={submitText}
              submitButton={submitButton}
              isValid={stepHasRequiredData(requiredData, userData, values)}
              dispatch={dispatch}
              values={values}
              waitText={getStepWaitText(requiredData, userData, values)}
              tracking={tracking}
              formParams={formParams}
              actionProps={actionProps}
              userData={userData}
              actionVariant={actionVariant}
              setFieldValue={setFieldValue}
              submitIcon={submitIcon}
              applyFormSubmitClass={applyFormSubmitClass}
              currentSectionId={currentSectionId}
            />
                }

            {afterButtonTextBody &&
            <p className="text__desc--afterButton">
              <Text value={afterButtonTextBody} />
            </p>
                }

          </div>
          )}

      </article>
    );
  }
}

export default Basic;

Basic.defaultProps = {
  actionProps: null,
  desc: null,
  errors: null,
  requiredData: {},
  submitButton: true,
  title: null,
  tracking: ['tealiumSubmit'],
  actionVariant: 'greyBox',
  className: '',
  submitIcon: true,
  applyFormSubmitClass: true,
  afterButtonTextBody: '',
};

Basic.propTypes = {
  componentProps: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  submitText: PropTypes.string.isRequired,
  currentSectionId: PropTypes.string.isRequired,
  actionProps: PropTypes.array,
  desc: PropTypes.string,
  actionVariant: PropTypes.string,
  errors: PropTypes.object,
  formActions: PropTypes.array.isRequired,
  tracking: PropTypes.array,
  handleSubmit: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  requiredData: PropTypes.object,
  setFormValues: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  submitButton: PropTypes.bool,
  title: PropTypes.string,
  touched: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  className: PropTypes.string,
  submitIcon: PropTypes.bool,
  applyFormSubmitClass: PropTypes.bool,
  afterButtonTextBody: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Steps/Basic/index.jsx